export var isMobile = window.matchMedia("(max-width: 767px)");
export var showStr = "display:block !important";
export var showStrNotImp = "display:block";
export var hideStr = "display:none !important";

export var mapConfig = {
    boundsOfAT: [
        [9.4, 49],
        [17.15, 46.4],
    ],
    layers: [
        {
            active: true,
            name: "Karte",
            style: "mapbox://styles/mapbox/streets-v10",
            selected: true,
        },
        {
            active: true,
            name: "Hybrid",
            style: "mapbox://styles/mapbox/satellite-streets-v9",
            selected: false,
        },
        {
            active: true,
            name: "Luftbilder",
            style: "mapbox://styles/mapbox/satellite-v9",
            selected: false,
        },
    ],
    basic: {
        style: "mapbox://styles/mapbox/streets-v10",
        iconPosition: "bottom-right",
        dragRotate: false,
        dragPan: true,
        touchZoomRotate: true,
        trackResize: true,
        attributionControl: false,
        padding: { top: 40, right: 50, bottom: 20, left: 20 },
        animateDuration: 300,
        animateSpeed: 2,
        maxZoom: 18,
    },
    resultList: {
        container: "mainMap",
        zoom: 14.5,
        padding: { top: 40, right: 50, bottom: 20, left: 20 },
        interactive: true,
    },
    overlay: {
        container: "overlayMap",
        zoom: 14.5,
        padding: { top: 40, right: 50, bottom: 20, left: 20 },
        interactive: true,
        scrollZoom: true,
    },
    iframe: {
        container: "map",
        zoom: 12,
        padding: { top: 20, right: 20, bottom: 20, left: 20 },
        interactive: true,
    },
    route: {
        container: "map",
        zoom: 14.5,
        padding: { top: 50, right: 100, bottom: 10, left: 520 },
        interactive: true,
        scrollZoom: true,
    },
};
export var controlPos = {
    tl: "top-left",
    tr: "top-right",
    bl: "bottom-left",
    br: "bottom-right",
};